import { Modal, showModal } from './bootstrap_components';

export function setupPlanPricesButtons() {
  $(document).off('turbo:before-cache.plan_prices_modal').on('turbo:before-cache.plan_prices_modal', () => {
    cleanupPlanPricesModalBeforeCache();
  });

  $(document).off('click.plan_prices_modal', '.plan-prices-button').on('click.plan_prices_modal', '.plan-prices-button', (event) => {
    event.preventDefault();

    var elt = $(event.currentTarget);
    var planName = elt.data('plan-name');
    var url = elt.data('prices-url');

    $('#plan-prices-modal-title').text(`Price history for ${planName}`);
    $('#plan-prices-modal-body').html('<p class="mb-0">Loading price history...</p>');
    showModal('#plan-prices-modal');

    $.get(url, (data) => {
      $('#plan-prices-modal-body').html(data);
    }).fail(() => {
      $('#plan-prices-modal-body').html('<p class="mb-0 text-danger">Failed to load price history.</p>');
    });
  });
}

function cleanupPlanPricesModalBeforeCache() {
  const $modal = $('#plan-prices-modal');
  if (!$modal.hasClass('show')) return;

  Modal.getInstance($modal[0])?.dispose();
  $modal.removeClass('show').attr('aria-hidden', 'true').removeAttr('aria-modal').hide();
  $('body').removeClass('modal-open').css('padding-right', '');
  $('.modal-backdrop').remove();
}
